export const countOrAcvComparer = type => type === "acv" ? true : false